



































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import {InputSelect} from "iwb_serenity";

export default Vue.extend({
    components: {
        InputSelect: InputSelect
    },
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: false,
            default: "selectInput"
        },
        ariaLabelTooltip: {
            type: String,
            required: false,
            default: ""
        },
        inputTooltip: {
            type: Boolean,
            required: false,
            default: false
        },
        inputLabel: {
            type: String,
            required: true
        },
        inputDescription: {
            type: String,
            required: false,
            default: "",
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: true
        },
        options: {
            type: Array,
            required: true
        },
        defaultValue: {
            type: String,
            required: false,
            default: ""
        },
        gridLayout: {
            type: String,
            required: false,
            default: ""
        },
        specificId: {
            type: String,
            required: false,
            default: ""
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        inputErrorLabelId: {
            type: String,
            required: false,
            default: "errorLabelId"
        },
        noMargin: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false
        },
        small: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            uniqueId: (this.specificId != "") ? this.specificId : uuidv4() as string
        };
    },
    computed: {
        className: function(): string {
            let className = "";
            if (this.gridLayout !== "") {
                className += this.gridLayout;
            }

            return className;
        }
    },
    methods: {
        updateValue: function (value: string) {
            this.$emit("update-value", value);
        }
    }
});
